import React from 'react';
import { Teacher } from './TeacherCard';

interface PurchaseButtonProps {
    selectedTeacher: Teacher | null;
    selectedDate: Date | null;
    selectedTime: Date | null;
    onClick: () => void;
}

const PurchaseButton: React.FC<PurchaseButtonProps> = ({
    selectedTeacher,
    selectedDate,
    selectedTime,
    onClick
}) => {
    console.log({selectedTeacher, selectedDate, selectedTime});

    return (
        <div className="purchase-button-container">
            <button
                className="purchase-button"
                onClick={onClick}
                disabled={!selectedTeacher || !selectedDate || !selectedTime}
            >
                {`Daftar`}
            </button>
        </div>
    );
};

export default PurchaseButton;